import { ChangeEvent, useState } from "react";

const useKatakomInput = (initialValue: string) => {
    const [value, setValue] = useState(initialValue);
    const [error, setError] = useState(false);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
    };

    return {
        value,
        error,
        onChange: handleChange,
        setError,
    };
};

export default useKatakomInput;
